import { TextIcon } from "../../../CommonUI/TextIcon";
import React from "react";
import { BaseJSONXMLElementEditor } from "./BaseJSONXMLElementEditor";
import { JSONXMLObjectElement } from "../../../rule-engine-core/TextMerge/Elements/JSONXML/JSONXMLObjectElement";

export class JSONXMLObjectEditor extends BaseJSONXMLElementEditor<JSONXMLObjectElement> {
    getIcon(): JSX.Element {
        return <TextIcon name={"{}"} />;
    }
}
